import BaseEvent from './BaseEvent.js';

class ForwardEvent extends BaseEvent {
  handle(msg) {
    this.context.listeners.forEach(callback => callback(msg));
  }
}

export default ForwardEvent;
